import React, { createContext, useContext, useState, useEffect } from 'react';
import { useCalendar } from './CalendarContext';
import moment from 'moment';

const CalendarEventContext = createContext(null);

export function CalendarEventProvider({ children }) {
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [selectedAction, setSelectedAction] = useState(localStorage.getItem("selectedAction") || "appointment"); // Should only be appointment or block

    const selectAndStoreAction = (action) => {
        setSelectedAction(action);
        localStorage.setItem("selectedAction", action);
    };

    const value = {
        selectedEvent,
        setSelectedEvent,
        selectedAction,
        setSelectedAction: selectAndStoreAction,
        events,
        setEvents
    };

    return (
        <CalendarEventContext.Provider value={value}>
        {children}
        </CalendarEventContext.Provider>
    );
}

export const useCalendarEvent = () => {
    const context = useContext(CalendarEventContext);
    if (!context) {
        throw new Error('useCalendarEvent must be used within a CalendarEventProvider');
    }
    return context;
}; 